module.exports = __webpack_public_path__ + "images/hue_thumb.png";